<div
  *ngIf="toastMessage"
  [ngClass]="{
    'custom-toast': true,
    'success': toastType === 'success',
    'error': toastType === 'error'
  }"
>
  <div class="toast-header">
    <strong class="toast-title">{{ toastType === 'success' ? 'Success' : 'Error' }}</strong>

    <button (click)="clearToast()" class="close-btn">&times;</button>
  </div>
  <div class="toast-body">
    <span class="status-code">{{ statusCode ? 'Status: ' + statusCode : '' }}</span>
    <p>{{ toastMessage }}</p>
  </div>
</div>
